// extracted by mini-css-extract-plugin
export default {"container":"page-section_container__Ab9di","headerContainer":"page-section_headerContainer__U+p4B"};